export default __webpack_public_path__ + "static/media/img20200226_100657.54dfb7d8.jpg";